<div class="breadcrumbs">
  <span class="title">Gestione Emergenze <mat-icon style="vertical-align: middle;">keyboard_arrow_right</mat-icon>
    Template segnalazioni </span>
</div>
<hr>

<div class="titolo flex-row-titolo">
  <div class="flex-display">
    <button mat-stroked-button class="pers" (click)="onNavigate()">
      <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
    </button>
    <div class="denom">
      <span class="h5 upp">Elenco template segnalazioni per {{ denominazione }}</span>
    </div>
  </div>

  <div class="combo">
    <button mat-stroked-button color='basic' class="pers2" (click)="showTemplateOption('')"
    *ngIf="isModifica && (this.acl != 'dgpe')">
      IMPORTA TEMPLATE
    </button>
    <button mat-stroked-button color='basic' class="pers2" (click)="showTemplateOption('nuovo')" *ngIf="isModifica && (this.acl != 'dgpe')">
      INSERISCI NUOVO TEMPLATE
    </button>
  </div>
</div>





<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
  <mat-expansion-panel-header class="colorSearch">
    <mat-panel-title class='search'>
      <mat-icon>search</mat-icon>
      <strong class="title">CERCA</strong>
      <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
      <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="coloredS" [formGroup]="form">


    <div class="flex-row-search">
      <mat-form-field appearance="fill" color='accent' class="searchbar">
        <mat-label for="codice template">Codice template</mat-label>
        <input type="number" matInput [formControlName]="'idTemplate'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class="searchbar">
        <mat-label for="descrizione">Descrizione</mat-label>
        <input matInput [formControlName]="'descrizione'">
      </mat-form-field>

      <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
        <input hidden matInput>
      </mat-form-field>
    </div>
    <div class="flex-row-search">
      <mat-form-field appearance="fill" color='accent' class="searchbar" *ngIf="!isDgpe">
        <mat-label for="idEvento">Tipo segnalazione</mat-label>
        <mat-select [formControlName]="'tpModulo'">
          <mat-option value=''></mat-option>
          <mat-option value="1" default>Richieste danni di tipo pubblico</mat-option>
          <mat-option value="2">Richieste danni di tipo privato</mat-option>
          <mat-option value="3">Richieste danni di tipo attività economiche</mat-option>
          <mat-option value="4">Modello libero</mat-option>
        </mat-select>
      </mat-form-field>



      <mat-form-field appearance="fill" color='accent' class="searchbar" *ngIf="!isDgpe">
        <mat-label for="orderBy">Distribuito</mat-label>
        <mat-select [formControlName]="'flDistribuito'">
          <mat-option value=''></mat-option>
          <mat-option value='S'> Sì </mat-option>
          <mat-option value='N'> No </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
        <input hidden matInput>
      </mat-form-field>

    </div>

  </div>
  <mat-action-row class='colored'>
    <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
    <button mat-raised-button class="pers2 big" color="accent" (click)="ricercaListaTemplate()">Cerca</button>
  </mat-action-row>
</mat-expansion-panel>




<mat-table [dataSource]="dataSource" matSort matSortActive="idTemplate" matSortDirection="asc"
  class="mat-elevation-z8 w" style="width: inherit;" matSortDisableClear>

  <ng-container matColumnDef="idTemplate">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Codice Template </mat-header-cell>
    <mat-cell [attr.data-label]="'Codice Template'" *matCellDef="let element"> {{element.idTemplate}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="tpModulo">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Tipo Segnalazione </mat-header-cell>
    <mat-cell [attr.data-label]="'Tipo Segnalazione'" *matCellDef="let element">
      {{element.descrTpTemplate}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="descrizione">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Descrizione </mat-header-cell>
    <mat-cell [attr.data-label]="'Descrizione'" *matCellDef="let element"> {{element.descrizione}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="flDistribuito">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Distribuito </mat-header-cell>
    <mat-cell [attr.data-label]="'Distribuito'" *matCellDef="let element">
      <span *ngIf="element.flDistribuito == 'S'">Sì</span>
      <span *ngIf="element.flDistribuito == 'N'">No</span>
      <span *ngIf="element.flDistribuito == 'D'">Distribuita</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Azioni </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span *ngIf="element.idTemplate !== openToggle" class="material-icons" (click)="openToggle = element.idTemplate" title="apri/chiudi toolbar">more_horiz</span>

      <myp-toolbar *ngIf="element.idTemplate === openToggle" [toolbar]="element.flDistribuito === 'S'?distribuitedtemplateCaseToolbar(element.tpModulo):toolbar" role=toolbar [data]="element"
        [data]="element"  (onToolbarEvent)="handleToolbarEvent($event)">
      </myp-toolbar>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns" ></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;" ></mat-row>

</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>
        Non ci sono risultati
      </h6>
    </mat-card-content>
  </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;"  id='paginator' [pageSize]="risultatiPerPagina" [pageSizeOptions]="[3, 5, 10]"></mat-paginator>
